import React from 'react';

import {REMOTE_CONFIG_PATHS} from '../../../constants/remoteConfigPaths';
import {DynamicContent} from '../../DynamicContent';

export const AleloInspection = () => {
  return (
    <DynamicContent
      configPath={REMOTE_CONFIG_PATHS.MERCHANT_POLICY.SECTIONS.ALELO_INSPECTION}
      renderAsHtml={true}
    />
  );
};
